<div class="info-alert-container d-flex align-items-center">
  <div class="icon-area">
    <img
      src="assets/imagenes/info-icon.png"
      width="20"
      height="20"
      alt="icon info"
    />
  </div>

  <div class="text-area">
    <strong class="info-title">{{ title }}</strong>
    <div class="info-content">
      <ng-content></ng-content>
    </div>
  </div>
</div>
